import logo from "../assets/images/logo/logo.png";

export { logo };

export const companyDetails = {
  phone: "+91 9281458988",
  email: "mandapatisolutions@gmail.com",
  address: "9-73, Beside Health plus water plant, Kamavarapu kota, AP - 534449, India",
  facebook: "https://www.facebook.com/people/MS/61554503012652/",
  instagram: "https://www.instagram.com/mandapatisolutions/",
  linkedin: "https://www.linkedin.com/company/mandapati-solutions",
  youtube: "https://www.youtube.com/@mandapatisolutions",
};

export const testimonials = [
  {
    id: 1,
    img: require("../assets/images/testimonial/1.jpg"),
    quote: `Mandapati Solutions transformed our business with their exceptional AI development services. 
  The intelligent automation system they built has streamlined our operations and increased our 
  productivity by 40%. Their team's expertise in machine learning and AI is truly remarkable, and 
  the results speak for themselves. We couldn't be happier with the partnership.`,
    position: "Operations Director, TechVentures",
    author: "Priya Sharma",
  },
  {
    id: 2,
    img: require("../assets/images/testimonial/2.jpg"),
    quote: `Working with Mandapati Solutions on our mobile application was an outstanding experience. 
  They delivered a beautiful, high-performance app that our customers absolutely love. The team 
  was professional, responsive, and truly understood our vision. Our app downloads have tripled 
  since launch, and user engagement is at an all-time high. Highly recommended!`,
    position: "CEO, RetailConnect",
    author: "Rajesh Kumar",
  },
  {
    id: 3,
    img: require("../assets/images/testimonial/3.jpg"),
    quote: `Mandapati Solutions built our entire e-commerce platform from scratch, and the results have 
  exceeded our expectations. Their full-stack development expertise is evident in every aspect of 
  the platform. The site is fast, secure, and handles high traffic seamlessly. Our online sales 
  have increased by 150% since the launch. They're true professionals.`,
    position: "Founder, StyleHub",
    author: "Surendhar Kumar",
  },
  {
    id: 4,
    img: require("../assets/images/testimonial/4.jpg"),
    quote: `The digital marketing strategies implemented by Mandapati Solutions have revolutionized our 
  online presence. Their data-driven approach and creative campaigns have significantly increased 
  our brand visibility and customer engagement. Our social media following has grown by 300%, and 
  our conversion rates have improved dramatically.`,
    position: "Marketing Head, InnovateNow",
    author: "Vikram Singh",
  },
  {
    id: 5,
    img: require("../assets/images/testimonial/5.jpg"),
    quote: `Mandapati Solutions provided comprehensive software training to our development team, and 
  the impact has been tremendous. Our team is now more confident and productive, implementing 
  best practices and modern development methodologies. The training was well-structured, practical, 
  and delivered by experts who truly understand the industry.`,
    position: "CTO, DataSystems Pro",
    author: "Arjun Mehta",
  },
];

// faq
export const faqs = [
  {
    id: 1,
    question: "What services does Mandapati Solutions offer?",
    answer:
      "We offer comprehensive technology solutions including AI Development, Mobile Application Development, Web Full-Stack Development, Digital Marketing, Online Store solutions, and Software Training. Our services are designed to help businesses grow and succeed in the digital landscape.",
  },
  {
    id: 2,
    question: "How does your development process work?",
    answer:
      "Our proven process ensures success through careful planning and execution. We begin with discovery and planning to understand your needs, followed by design and development, rigorous testing and quality assurance, and finally launch with ongoing support. Each phase is executed with meticulous attention to detail and a commitment to your success.",
  },
  {
    id: 3,
    question: "What is included in your Web Full-Stack Development service?",
    answer:
      "Our full-stack development services include frontend and backend development, database design, API integration, responsive design, e-commerce solutions, content management systems, and ongoing maintenance. We build scalable, secure, and high-performance web applications tailored to your business needs.",
  },
  {
    id: 4,
    question: "Do you provide AI development services?",
    answer:
      "Yes! We specialize in AI development solutions including machine learning models, intelligent automation, predictive analytics, chatbots, computer vision, and custom AI applications. Our AI solutions help businesses automate processes, gain insights, and make data-driven decisions.",
  },
  {
    id: 5,
    question: "What platforms do you support for mobile app development?",
    answer:
      "We develop mobile applications for both iOS and Android platforms, as well as cross-platform solutions. Our mobile apps are designed for optimal performance, user experience, and scalability across all devices and screen sizes.",
  },
  {
    id: 6,
    question: "What digital marketing services do you offer?",
    answer:
      "Our digital marketing services include social media marketing, SEO optimization, content marketing, PPC campaigns, email marketing, brand strategy, and analytics. We create data-driven campaigns that increase brand visibility, engagement, and conversions.",
  },
  {
    id: 7,
    question: "Can you help us set up an online store?",
    answer:
      "Absolutely! We provide complete online store solutions including e-commerce platform development, payment gateway integration, inventory management, order processing, secure checkout, and mobile-responsive design. We build online stores that drive sales and provide excellent customer experiences.",
  },
  {
    id: 8,
    question: "What software training programs do you offer?",
    answer:
      "We offer comprehensive software training programs covering modern programming languages, frameworks, development methodologies, cloud technologies, and best practices. Our training is hands-on, practical, and designed to upskill your team with industry-relevant skills.",
  },
];

// why work with us
export const whyworkwithus = [
  {
    id: 1,
    img: require("../assets/images/why work with us/1.webp"),
    title: "Tailored Solutions",
    description:
      "We understand that every business is unique. Our solutions are customized to meet your specific requirements and business objectives.",
  },
  {
    id: 2,
    img: require("../assets/images/why work with us/2.webp"),
    title: "Expert Team",
    description:
      "Our team of skilled professionals brings years of experience in AI, mobile development, web technologies, and digital marketing.",
  },
  {
    id: 3,
    img: require("../assets/images/why work with us/3.webp"),
    title: "Cutting-Edge Technology",
    description:
      "We leverage the latest technologies and frameworks to deliver innovative solutions that keep your business competitive.",
  },
  {
    id: 4,
    img: require("../assets/images/why work with us/4.webp"),
    title: "Results-Driven Approach",
    description:
      "We focus on delivering measurable results that drive growth, improve efficiency, and maximize your return on investment.",
  },
  {
    id: 5,
    img: require("../assets/images/why work with us/5.webp"),
    title: "End-to-End Support",
    description:
      "From initial consultation to deployment and beyond, we provide comprehensive support to ensure your success every step of the way.",
  },
];

// core values
export const coreValues = [
  {
    title: "Innovation First",
    desc: "We embrace cutting-edge technologies and innovative approaches to solve complex business challenges. Our commitment to innovation ensures our clients stay ahead in an ever-evolving digital landscape.",
  },
  {
    title: "Client-Centric Excellence",
    desc: "Our clients are at the heart of everything we do. We listen, understand, and deliver solutions that exceed expectations while building lasting partnerships based on trust and mutual success.",
  },
  {
    title: "Integrity and Transparency",
    desc: "We conduct business with the highest ethical standards, maintaining transparency in all our dealings. Our clients trust us because we deliver on our promises with honesty and integrity.",
  },
  {
    title: "Quality and Precision",
    desc: "We are committed to delivering excellence in every project. From initial concept to final deployment, we maintain the highest standards of quality, ensuring robust, scalable, and reliable solutions.",
  },
  {
    title: "Continuous Learning",
    desc: "The technology landscape evolves rapidly, and so do we. Our team continuously updates skills and knowledge to provide the most current and effective solutions to our clients.",
  },
  {
    title: "Collaborative Partnership",
    desc: "We believe in working together as a team with our clients. Through open communication and collaborative problem-solving, we achieve results that drive real business value.",
  },
  {
    title: "Results-Driven Approach",
    desc: "We focus on delivering measurable outcomes that impact your bottom line. Every solution we build is designed to drive growth, improve efficiency, and maximize return on investment.",
  },
  {
    title: "Scalability and Future-Proofing",
    desc: "We build solutions that grow with your business. Our forward-thinking approach ensures your technology investments remain relevant and valuable as your needs evolve.",
  },
  {
    title: "Security and Reliability",
    desc: "We prioritize security and reliability in every solution we deliver. Your data and systems are protected with industry-leading security practices and robust infrastructure.",
  },
];

// web development portfolio
export const webDevelopmentPortfolio = [
  {
    id: 1,
    title: "5G Homes",
    image: require("../assets/images/portfolio/web development/5ghomes.webp"),
  },
  {
    id: 2,
    title: "Autopilot",
    image: require("../assets/images/portfolio/web development/Autopilot.png"),
  },
  {
    id: 3,
    title: "Bayut",
    image: require("../assets/images/portfolio/web development/bayut.webp"),
  },
  {
    id: 4,
    title: "Cold Creekcap",
    image: require("../assets/images/portfolio/web development/cold creekcap.webp"),
  },
  {
    id: 5,
    title: "College Nutritionist",
    image: require("../assets/images/portfolio/web development/collegenutritionist.png"),
  },
  {
    id: 6,
    title: "Leadership.net",
    image: require("../assets/images/portfolio/web development/leadership.net.png"),
  },
  {
    id: 7,
    title: "Menissa Caterings",
    image: require("../assets/images/portfolio/web development/menissa caterings.webp"),
  },
  {
    id: 8,
    title: "Think Reality",
    image: require("../assets/images/portfolio/web development/think reality.webp"),
  },
];

// app development portfolio
export const appDevelopmentPortfolio = [
  {
    id: 1,
    title: "Cryptopadie",
    image: require("../assets/images/portfolio/app development/cryptopadie.png"),
  },
  {
    id: 2,
    title: "Doctor Plus",
    image: require("../assets/images/portfolio/app development/doctorplus.png"),
  },
  {
    id: 3,
    title: "Dubai Travel Guide",
    image: require("../assets/images/portfolio/app development/dubai travel guide.webp"),
  },
  {
    id: 4,
    title: "Elora Hair Palour",
    image: require("../assets/images/portfolio/app development/elora hair palour.webp"),
  },
  {
    id: 5,
    title: "Evans Francis",
    image: require("../assets/images/portfolio/app development/evans francis.webp"),
  },
  {
    id: 6,
    title: "House of Deliverance",
    image: require("../assets/images/portfolio/app development/house of deliverance.png"),
  },
  {
    id: 7,
    title: "MyBitsShop",
    image: require("../assets/images/portfolio/app development/mybitsshop.webp"),
  },
  {
    id: 8,
    title: "Namaz",
    image: require("../assets/images/portfolio/app development/namaz.webp"),
  },
  {
    id: 9,
    title: "Potea",
    image: require("../assets/images/portfolio/app development/potea.webp"),
  },
  {
    id: 10,
    title: "Rentop",
    image: require("../assets/images/portfolio/app development/rentop.png"),
  },
];
